import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { EmployerMailingAddressFormGroup } from '../../../../../forms/employer-mailing-address-form-group';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CANADA_COUNTRY_ID } from '../../../../../consts/consts';

@Component({
  selector: 'app-mailing-address-form-grid',
  templateUrl: './mailing-address-form-grid.component.html',
  styleUrls: ['./mailing-address-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MailingAddressFormGridComponent implements OnInit {
  @Input({ required: true }) form!: EmployerMailingAddressFormGroup;
  @Input() formSubmitted = false;

  private destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.form.controls.sameAsHeadOffice.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(sameAsHeadOffice => {
        if (sameAsHeadOffice) {
          this.form.controls.address.reset({ countryId: CANADA_COUNTRY_ID });
          this.form.controls.address.disable();
        } else {
          this.form.controls.address.enable();
        }
      });
  }
}
